import { useCallback, useState } from 'react';

export const useTermsToggle = () => {
  const [isTermsOpen, setIsTermsOpen] = useState(false);

  const handleTermsToggle = useCallback((isOpen: boolean) => {
    setIsTermsOpen(isOpen);
  }, []);

  return { isTermsOpen, handleTermsToggle };
};
